// extracted by mini-css-extract-plugin
export default {"cls1":"UmaetYyeYGCoIFLiGgDz","cls2":"exr8BzLA_0mshJ_p6YNE UmaetYyeYGCoIFLiGgDz"};